import React, { useEffect, useState } from "react";
import { SelectInputWTitle } from "./SelectInputWTitle";
import { Loading } from "../Loading";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { LoadingColor } from "../LoadingColor";


export const ServiceTypeV2Selector = ({
    style,
    name,
    title,
    error = "",
    first,
    value,
    onchange,
    placeHolder,
    selectableFirst,
    required,
    ltr,
    lan= false,
    disabled=false,
    search= false
}) => {
    const data = [
        {
            "Service_Type": 1,
            "Class_Type_Name": "هتل",
            "Class_Type_EnName": "Hotel"
        },
        {
            "Service_Type": 2,
            "Class_Type_Name": "کارگزار",
            "Class_Type_EnName": "Broker"
        }
    ]
    let options = data.map((v) => {
        return {
            value: v.Service_Type,
            name: (lan) ? v.Class_Type_EnName : v.Class_Type_Name
        }
    })
    return (
        <SelectInputWTitle
            style={style}
            name={name}
            title={title}
            error={error}
            options={options}
            first={first}
            value={value}
            onchange={onchange}
            selectableFirst={selectableFirst}
            placeHolder={placeHolder}
            required={required}
            ltr={ltr}
            lan={lan}
            disabled={disabled}
            search={search}
        />
    )

};